

































































import { Button } from 'element-ui'
import { Vue, Prop, Component } from 'vue-property-decorator'

import RoundAvatar from '@/components/RoundAvatar.vue'
import StatusLabel from '@/components/StatusLabel.vue'

import Currency from '@/models/currency'
import Passenger, { PassengerStatuses } from '@/models/passenger'
import Recipient from '@/models/recipient'

@Component({
  components: {
    RoundAvatar,
    [Button.name]: Button,
    StatusLabel,
  },
})
export default class PassengersPaymentTab extends Vue {
  @Prop() passengers!: Passenger[]
  @Prop() chosenPassengers!: { [id: number]: Recipient }
  @Prop() submitDisabledProp!: boolean
  @Prop(String) currencyCode!: Currency
  @Prop({ default: true }) showOutstanding!: boolean
  @Prop({ default: true }) showLabels!: boolean

  get submitDisabled(): boolean {
    return this.submitDisabledProp || this.noPassengersChosen
  }

  get noPassengersChosen() {
    return !this.passengers.find(
      (passenger) =>
        this.chosenPassengers[passenger.id] &&
        this.chosenPassengers[passenger.id].isChosen,
    )
  }

  get currentCustomerId() {
    return this.$store.getters.getCurrentCustomer.id
  }

  currentPassengerIsLead() {
    const booking = this.$store.getters.getBooking(this.passengers[0].bookingId)
    return booking.customerId === this.currentCustomerId
  }

  passengerNameField(passenger: Passenger): string[] {
    if (passenger.fullName.trim().length !== 0) {
      return [passenger.firstName, passenger.lastName]
    }
    if (passenger.passengerStatus === PassengerStatuses.Cancelled) {
      return ['Guest']
    }

    return this.currentPassengerIsLead() && !passenger.email
      ? ['Invite', 'Guest']
      : ['Invited', 'Guest']
  }

  iconClass(passenger: Passenger) {
    if (passenger.customerId || passenger.fullName.trim().length > 0) {
      return null
    }
    if (this.currentPassengerIsLead()) {
      return passenger.email ? 'sc-icon-person' : 'sc-icon-add'
    } else {
      return 'sc-icon-person'
    }
  }

  labelFor(passenger: Passenger): string | null {
    if (!this.showLabels) {
      return null
    }

    if (passenger.passengerStatus === PassengerStatuses.Cancelled) {
      return 'cancelled'
    } else if (passenger.amountPaidCents >= passenger.totalPriceCents) {
      return 'fully_paid'
    } else if (passenger.depositOutstandingCents <= 0) {
      return 'deposit'
    } else {
      return null
    }
  }

  choosePassenger(passengerId: number) {
    this.$emit('on-passenger-choice', passengerId)
  }
}
